import { DOOR_KEEPER_API } from '~/config';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

type BuildProviderUrlParams = {
  apiOrigin: string;
  authUrl: string;
  clientId: string;
  redirectPath: string;
};

const useBPDOAuthLogin = () => {
  const { pathname } = useRouter();

  const buildProviderUrl = ({
    apiOrigin,
    authUrl,
    clientId,
    redirectPath,
  }: BuildProviderUrlParams) => {
    const url = new URL(authUrl);
    url.searchParams.set('client_id', clientId);
    url.searchParams.set('redirect_uri', `${apiOrigin}${redirectPath}`);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('scope', 'read');
    return url;
  };

  const login = () => {
    const providerUrl = buildProviderUrl(DOOR_KEEPER_API);
    Cookies.set('requestedLocation', pathname);
    window.location.replace(providerUrl);
  };

  const errors = {
    access: Cookies.get('access'),
    concurrent_session: Cookies.get('concurrent_session'),
  };

  return {
    login,
    errors,
  };
};

export default useBPDOAuthLogin;
